export function getProductionErrorMessage(
  error,
  fallback = "No se pudo completar la operación."
) {
  const message =
    error?.response?.data?.detail ||
    error?.response?.data?.message ||
    error?.data?.detail ||
    error?.data?.message ||
    error?.message;

  return Array.isArray(message) ? message.join(" · ") : message || fallback;
}
